import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {WhatRouter} from "../../../../components/help/CommonQuestions.tsx";
import {Link} from "react-router-dom";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";

export default function BridgeModeArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className={'article'}>
                    <div className={'text-box text-box--gray'}>
                        <p>
                            Er du i tvivl om, om du kan bruge din egen router på din forbindelse?
                            Du kan læse mere om eget udstyr <Link to={"/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr"}>lige&nbsp;her</Link>!
                        </p>
                    </div>
                </div>

                <div className={'article'}>
                    <h2>
                        Vælg din router for at finde vejledning
                    </h2>
                    <div className={'choose-router-container'}>
                        <a href={'#fiber'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex33}
                                    alt={'Billede af vores Zyxel EX/VMG router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX33/EX36/VMG
                            </span>
                        </a>
                        <a href={'#fiber'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_ex56}
                                    alt={'Billede af vores Zyxel EX5601 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel EX5601
                            </span>
                        </a>
                        <a href={'#sagemcom-3890'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.sagemcom_3890}
                                    alt={'Billede af vores Sagemcom 3890 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Sagemcom 3890
                            </span>
                        </a>
                        <a href={'#sagemcom-3896'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.sagemcom_3896}
                                    alt={'Billede af vores Sagemcom 3896 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Sagemcom 3896
                            </span>
                        </a>
                        <a href={'#zyxel-nr5307'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.zyxel_nr5307}
                                    alt={'Billede af vores Zyxel NR5307 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Zyxel NR5307
                            </span>
                        </a>
                        <a href={'#huawei-h158'} className={'choose-router'}>
                            <div className={'image-container'}>
                                <img
                                    className={'no-br'}
                                    src={imageMap.help.choose_router.huawei_h158}
                                    alt={'Billede af vores Huawei H158 router.'}
                                />
                            </div>
                            <span className={'text'}>
                                Huawei H158
                            </span>
                        </a>
                        <a href={'#not-sure'} className="not-sure">
                            <span className={'text'}>
                                Ved du ikke hvilken router du har?
                            </span>
                        </a>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <h2>Zyxel EX33/EX36/VMG og Zyxel EX5601</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Sørg for at din enhed er forbundet til routerens netværk via wifi eller et netværkskabel.
                            </p>
                        </li>
                        <li>
                            <p>
                                Åbn en browser.
                            </p>
                        </li>
                        <li>
                            <p>
                                Indtast &ldquo;192.168.1.1&rdquo; i adressefeltet.
                            </p>
                        </li>
                        <li>
                            <p>
                                Nu kommer du til en login-side.
                            </p>
                            <p>
                                Hvis du ikke lander på en login-side som på billedet, skal du tjekke for stavefejl og sikre, at din enhed er forbundet til routeren.
                            </p>
                        </li>
                        <img src={imageMap.help.network.gui.zyxel.zyxelGuiLogin} alt="Grafik som illustrerer Log-in siden på en Zyxel router."/>
                        <li>
                            <p>
                                Angiv &ldquo;admin&rdquo; som <strong>User Name</strong> og &ldquo;1234&rdquo; som <strong>Password</strong>.
                            </p>
                            <p>
                                Hvis koden &ldquo;1234&rdquo; ikke virker, skal du bruge koden på bagsiden af routeren ved <strong>Login Password</strong>.
                                Første gang du logger ind, bliver du bedt om at lave en ny username/password-kombination.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_ex3.gui_login}
                            alt="Grafik som viser &ldquo;Login Password&rdquo; på bagsiden af routeren."
                        />
                        <li>
                            <p>
                                Når du er logget ind, klik på <strong>{">"}</strong> i <strong>WiFi&nbsp;Settings</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiHomeWifi}
                            alt="Grafik af GUI&rsquo;en på en Zyxel router med fokus på &ldquo;WiFi Settings&rdquo;."
                        />
                        <li>
                            <p>
                                Slå <strong>2.4G&nbsp;WiFi</strong> og <strong>5G&nbsp;WiFi</strong> fra.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Save</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiWifiSettings}
                            alt="Grafik af Zyxel routerens interface hvor man kan deaktivere wifi."
                        />
                        <li>
                            <p>
                                Tryk på menuen &#9776; oppe i højre hjørne.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Network&nbsp;Setting</strong> {">"} <strong>Home&nbsp;Networking</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiMenuHomeNetworking}
                            alt="Grafik af Zyxel routerens interface der viser en menu."
                        />
                        <li>
                            <p>
                                Sæt <strong>DHCP Server State</strong> til <strong>Disable</strong> og slå <strong>LAN IPv6 Mode Setup</strong> fra.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiHomeNetworkingLan}
                            alt="Grafik af Zyxel routerens interface der viser en menu."
                        />
                        <li>
                            <p>
                                Tryk igen på menuen &#9776; oppe i højre hjørne.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Network Setting</strong> {">"} <strong>Broadband</strong>.
                            </p>
                            <p>
                                Har du <strong>fiber</strong>, skal du trykke på papiret med blyanten under <strong>Modify</strong> under <strong>ETHWAN</strong>.
                            </p>
                            <p>
                                Har du <strong>internet via telefonstikket</strong>, skal du trykke på papiret med blyanten under <strong>Modify</strong> i enten <strong>VDSL</strong> eller <strong>ADSL</strong>.
                            </p>
                            <p>
                                Er du i tvivl om, hvilken du skal vælge?
                                Kontakt vores support på <a href="tel:+4588772000">88&nbsp;77&nbsp;20&nbsp;00</a>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiBroadband}
                            alt="Grafik af Zyxel routerens interface der viser en menu."
                        />
                        <li>
                            <p>
                                Under <strong>General</strong> skal du ændre <strong>Mode</strong> fra <strong>Routing</strong> til <strong>Bridge</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Apply</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel.zyxelGuiWanInterfaceBridgeMode}
                            alt="Grafik af Zyxel routerens interface der viser en menu."
                        />
                        <li>
                            <p>
                                Routeren fra os er nu i bridge mode.
                            </p>
                            <p>
                                Du kan forbinde din router til vores, ved at sætte et netværkskabel i en vilkårlig LAN-port på vores router og i WAN-porten på din egen router.
                            </p>
                        </li>
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'sagemcom-3890'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className={'paragraph'}>
                        <h2>Sagemcom 3890</h2>
                        <div className={'text-box text-box--gray'}>
                            <p>
                                <strong>Inden du går i gang:</strong>{' '}
                                Der kan gå op til 2 timer, før dit internet virker igen, efter du har sat routeren i bridge mode.
                            </p>
                        </div>
                        <ol className="list list--number list--image">
                            <li>
                                <p>
                                    Sørg for at din enhed er forbundet til routerens netværk enten via wifi eller et netværkskabel.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Åbn en browser.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Indtast &ldquo;192.168.0.1&rdquo; i adressefeltet.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Skriv login-informationerne til routeren.
                                    De står på klistermærket på siden af routeren.
                                </p>
                            </li>
                            <img
                                className="no-br"
                                src={imageMap.help.network.gui.sagemcom_3890.router_login}
                                alt="Grafik af Sagemcom routerens side der viser mærkaten med login informationer."
                            />
                            <li>
                                <p>
                                    Tryk på <strong>Mit WiFimodem</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.sagemcom_3890.sagemGuiHomeMitWifiModem}
                                alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Mit WiFimodem&rdquo; knappen."
                            />
                            <li>
                                <p>
                                    Tryk på <strong>Bridge Mode</strong>.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Tryk på <strong>ON/OFF</strong> for at aktivere.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.sagemcom_3890.sagemGuiBridgeModeActivate}
                                alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Bridge Mode&rdquo; siden og &ldquo;ON/OFF&rdquo; knappen."
                            />
                            <li>
                                <p>
                                    Tryk <strong>Anvend</strong> for at gemme indstillingerne.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.sagemcom_3890.sagemGuiBridgeModeApply}
                                alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Anvend&rdquo; knappen på &ldquo;Bridge Mode&rdquo; siden."
                            />
                            <li>
                                <p>
                                    Routeren fra os er nu i bridge mode.
                                </p>
                                <p>
                                    Du kan forbinde din router til vores, ved at sætte et netværkskabel i en vilkårlig LAN-port på vores router og i WAN-porten på din egen router.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'sagemcom-3896'} className={'id-anchor--help'}/>
                <div className="article">
                    <h2>Sagemcom 3896</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Sørg for at din enhed er forbundet til routerens netværk enten via wifi eller et netværkskabel.
                            </p>
                        </li>
                        <li>
                            <p>
                                Åbn en browser.
                            </p>
                        </li>
                        <li>
                            <p>
                                Indtast &ldquo;192.168.0.1&rdquo; i adressefeltet.
                            </p>
                        </li>
                        <li>
                            <p>
                                Skriv login-informationerne til routeren.
                                De står på klistermærket på undersiden af routeren.
                            </p>
                        </li>
                        <img
                            className="no-br"
                            src={imageMap.help.network.gui.sagemcom_3896.router_login}
                            alt="Grafik af Sagemcom routerens side der viser mærkaten med login informationer."
                        />
                        <li>
                            <p>
                                Tryk på <strong>Min Sagemcom Router</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.sagemcom_3896.home_router}
                            alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Mit WiFimodem&rdquo; knappen."
                        />
                        <li>
                            <p>
                                Tryk på <strong>NAT Mode</strong> fanen.
                            </p>
                        </li>
                        <li>
                            <p>
                                Ændr <strong>NAT Mode</strong> til <strong>Bridge Mode</strong> og tryk derefter <strong>Anvend</strong>.
                            </p>
                        </li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.sagemcom_3896.bridge_mode_activate}
                            alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Mit WiFimodem&rdquo; knappen."
                        />
                        <li>
                            <p>
                                Tryk <strong>Ja</strong> i dialogboksen.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.sagemcom_3896.bridge_mode_confirm}
                            alt="Grafik af Sagemcom routerens GUI, der viser &ldquo;Anvend&rdquo; knappen på &ldquo;Bridge Mode&rdquo; siden."
                        />
                        <li>
                            <p>
                                Routeren fra os er nu i bridge mode.
                            </p>
                            <p>
                                Du kan forbinde din router til vores ved at sætte et netværkskabel i en vilkårlig LAN-port på vores router og i WAN-porten på din egen router.
                            </p>
                        </li>
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'zyxel-nr5307'} className={'id-anchor--help'}/>
                <div className="article">
                    <h2>Zyxel NR5307</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Åbn en browser.
                            </p>
                        </li>
                        <li>
                            <p>
                                Indtast &ldquo;192.168.1.1&rdquo; i adressefeltet.
                            </p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>
                                        Hvis du har ændret routerens IP-adresse, skal du indtaste den i stedet.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Log ind med det <strong>Username</strong> og <strong>Password</strong>, som står bag på din router.
                            </p>
                        </li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelNr5307RouterLogin}
                            alt="Grafik af Zyxel NR5307 routerens side der viser mærkaten med login informationer."
                        />
                        <li>
                            <p>
                                Vælg <strong>{">"}</strong> i <strong>WiFi&nbsp;Settings</strong>.
                            </p>
                        </li>
                        <img
                            className={'no-br'}
                            src={imageMap.help.network.gui.zyxel.zyxelGuiHomeWifi}
                            alt="Grafik af Zyxel NR5307 routerens side der viser mærkaten med login informationer."
                        />
                        <li>
                            <p>
                                Deaktivér wifi ved at slå <strong>2.4G&nbsp;WiFi</strong> og <strong>5G&nbsp;WiFi</strong> fra.
                            </p>
                        </li>
                        <li>
                            <p>
                                Tryk <strong>Save</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Tryk på menuen <strong>&#9776;</strong> oppe i højre hjørne.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Network Setting</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Wireless</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelnr5307NetworkSetting}
                            alt="Grafik af Zyxel Routers admin, hvor du kan vælge nætværks indstillinger."
                        />
                        <li>
                            <p>
                                Gå til <strong>MESH</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelnr5307NetworkSettingMesh}
                            alt="Grafik af Zyxel NR5307 router der beskriver fravælgelse af Mesh."
                        />
                        <li>
                            <p>
                                Slå <strong>MPro Mesh</strong> fra.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelnr5307NetworkSettingMeshOff}
                            alt="Grafik af Zyxel NR5307 router der beskriver fravælgelse af Mesh tæt på."
                        />
                        <li>
                            <p>
                                Tryk <strong>Apply</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Tryk igen på menuen <strong>&#9776;</strong> og vælg <strong>Network Setting</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Home Networking</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Sæt <strong>DHCP Server State</strong> til <strong>Disable</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Slå <strong>IPv6 Active</strong> fra.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelnr5307NetworkSettingIPv4Off}
                            alt="Grafik af Zyxel NR5307 router der beskriver fravælgelse af IPv4."
                        />
                        <li>
                            <p>
                                Gå til menuen og vælg <strong>Network Setting</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Broadband</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Cellular IP Passthrough</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Slå <strong>IP Passthrough</strong> til.
                            </p>
                        </li>
                        <li>
                            <p>
                                Vælg <strong>Apply</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.zyxel_nr5307.zyxelnr5307NetworkSettingCellularOn}
                            alt="Grafik af Zyxel NR5307 router der beskriver tilvælgelse af cellurlar IP passthrough."
                        />
                        <li>
                            <p>
                                Nu er din router i bridge mode!
                            </p>
                        </li>
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'huawei-h158'} className={'id-anchor--help'}/>
                <div className="article">
                    <h2>Huawei H158</h2>
                    <ol className="list list--number list--image">
                        <li>
                            <p>
                                Åbn en browser og indtast &ldquo;192.168.8.1&rdquo; i adressefeltet.
                            </p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>
                                        Hvis du har ændret routerens IP-adresse, skal du indtaste den i stedet.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Log ind med det <strong>Password</strong>, som står under din router.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.gui_login}
                            alt="Grafik der viser login informationen på Huawei H158 routeren."
                        />
                        <li>
                            <p>
                                Vælg <strong>Avanceret</strong> i den blå menu.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.home_advanced}
                            alt="Billede der viser top menuen i Huawei H158 routerens GUI."
                        />
                        <li>
                            <p>
                                Navigér til <strong>Router</strong> og derefter <strong>Brotilstand</strong>, og slå bridge mode til ved <strong>Aktivér brotilstand</strong>.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.bridge_mode}
                            alt="Billede der viser bridge mode indstillingerne i Huawei H158 routerens GUI."
                        />
                        <li>
                            <p>
                                Når beskeden <strong>Lykkedes</strong> kommer frem, er din router i bridge mode.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.gui.huawei_158.bridge_mode_success}
                            alt="Billede af success beskeden man får, efter at have aktiveret bridge mode."
                        />
                    </ol>
                </div>

                <hr/>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>{WhatRouter.question}</h2>
                        {WhatRouter.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "vlan-tagging",
                        "name": "Hvordan VLAN-tagger jeg?"
                    },
                    {
                        "category": "udstyr",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
